var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-phone';
                    var viewUrl = 'sprite.svg#view-icon-phone';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'sprite.svg?icon-phone#icon-phone';
                            viewUrl = 'sprite.svg?icon-phone#view-icon-phone';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 13.3 13.3',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };